import { message } from 'antd';
import { POST } from 'src/network/apiHandler';
import config from 'src/globals';
import {
  FETCH_PAYOUTS,
  GET_PAYOUT_MASTER_DATA,
  GET_INVOICE_MASTER_DATA,
  FETCH_RECEIVABLES_INVOICE,
} from 'src/api/routes';
import {
  SET_RECEIVABLES_DATA,
  SET_RECEIVABLES_LOADER,
  SET_PAYOUT_BUCKET_DATA,
  SET_RECEIVABLES_INVOICE_DATA,
  SET_INVOICE_MASTER_DATA,
  SET_PAYOUT_EVENTS,
  PAYOUT_EVENTS_LOADING,
  PAYOUT_EVENTS_ERROR,
  SET_COMPUTATION_HEADERS_TO_SHOW,
  RESET_RECEIVABLES_DATA,
} from 'src/common/actions/constants';
import { getPayoutEvents } from './Receivables.api';

const { FINANCE_SERVICE_URL } = config;

const resolvePayoutMasterData = (payoutData) => {
  const { views: viewBlocks = [], ...basePayoutData } = payoutData || {};
  const views = viewBlocks.map((view) => ({
    ...view,
    resolved: { ...basePayoutData, ...view.payoutData },
  }));
  const [defaultView] = views;

  return {
    ...(defaultView?.resolved || basePayoutData),
    views,
    active_view_type: defaultView?.key,
  };
};

export const setActiveViewType = (viewKey: string) => (dispatch, getState) => {
  const { views = [] } = getState()?.receivables || {};
  const activeView = views.find((view) => view.key === viewKey);
  if (!activeView) {
    return;
  }

  dispatch({
    type: SET_PAYOUT_BUCKET_DATA,
    data: {
      ...activeView.resolved,
      views,
      active_view_type: activeView.key,
    },
  });
};

export const getPayoutMasterData = () => async (dispatch) => {
  dispatch({ type: SET_RECEIVABLES_LOADER, data: true });
  const response = await POST(`${FINANCE_SERVICE_URL}${GET_PAYOUT_MASTER_DATA}`, {});
  if (response.isSuccess && response.data) {
    dispatch({
      type: SET_PAYOUT_BUCKET_DATA,
      data: resolvePayoutMasterData(response.data),
    });

    if (response.data.computation_headers_to_show) {
      dispatch({
        type: SET_COMPUTATION_HEADERS_TO_SHOW,
        data: response.data.computation_headers_to_show,
      });
    }
  } else {
    message.error(response.errorMessage || 'Failed to fetch master data');
  }
  dispatch({ type: SET_RECEIVABLES_LOADER, data: false });
};

export const fetchPayoutData = (data) => async (dispatch) => {
  dispatch({ type: RESET_RECEIVABLES_DATA });
  dispatch({ type: SET_RECEIVABLES_LOADER, data: true });
  const response = await POST(`${FINANCE_SERVICE_URL}${FETCH_PAYOUTS}`, data);
  if (response.isSuccess) {
    dispatch({
      type: SET_RECEIVABLES_DATA,
      data: response.data,
    });
  } else {
    message.error(response.errorMessage || 'Failed to fetch payout data');
  }
  dispatch({ type: SET_RECEIVABLES_LOADER, data: false });
};

export const getInvoiceMasterData = () => async (dispatch) => {
  dispatch({ type: SET_RECEIVABLES_LOADER, data: true });
  const response = await POST(`${FINANCE_SERVICE_URL}${GET_INVOICE_MASTER_DATA}`, {});

  if (response.isSuccess && response.data) {
    dispatch({
      type: SET_INVOICE_MASTER_DATA,
      data: response.data,
    });
  }
  dispatch({ type: SET_RECEIVABLES_LOADER, data: false });
};

export const fetchInvoiceData = (data) => async (dispatch) => {
  dispatch({ type: SET_RECEIVABLES_LOADER, data: true });
  const response = await POST(`${FINANCE_SERVICE_URL}${FETCH_RECEIVABLES_INVOICE}`, data);

  if (response.isSuccess) {
    dispatch({
      type: SET_RECEIVABLES_INVOICE_DATA,
      data: response.data,
    });
  } else {
    message.error(response.errorMessage || 'Failed to fetch invoices');
  }
  dispatch({ type: SET_RECEIVABLES_LOADER, data: false });
};

export const fetchPayoutEvents = (payoutId: string) => async (dispatch, getState) => {
  dispatch({ type: PAYOUT_EVENTS_LOADING });

  const response = await getPayoutEvents(
    { id: payoutId.toString() },
    getState()?.receivables?.activeViewType,
  );

  if (response.success || response.isSuccess) {
    const eventsData = response.data || [];
    dispatch({
      type: SET_PAYOUT_EVENTS,
      data: eventsData,
    });
  } else {
    dispatch({
      type: PAYOUT_EVENTS_ERROR,
      data: response.message || response.errorMessage || 'Failed to fetch events',
    });
  }
};

export const clearPayoutEvents = () => ({
  type: SET_PAYOUT_EVENTS,
  data: [],
});
